import { LeaderContent } from "../../components/boundary/leader/content";

export default function Leader () {

  return (

    <>
        <LeaderContent/>
    </>

  )

}